<form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">
    <div class="flex flex-col items-center space-y-10 divide-y divide-gray-900/10">
      <!-- Page Title -->
      <div class="w-full max-w-6xl px-4 py-6 sm:px-8">
        <h1 class="text-3xl font-bold leading-8 text-gray-900">Core Setup</h1>
      </div>
  
      <!-- Profile Header -->
      <div class="w-full max-w-6xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-2">
  
          <!-- Tenant Information Card -->
          <div class="bg-white shadow-lg ring-1 ring-gray-900/10 sm:rounded-xl w-full">
            <div class="px-4 py-6 sm:p-8">
              <fieldset class="space-y-6">
                <legend class="text-lg font-semibold leading-6 text-gray-900">Tenant Information</legend>
                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
                  <!-- Tenant Name (Required) -->
                  <div class="sm:col-span-2">
                    <label for="tenant-name" class="block text-sm font-medium leading-6 text-gray-900">
                      Tenant Name <span class="text-red-600">*</span>
                    </label>
                    <div class="mt-2">
                      <input formControlName="tenantName" type="text" id="tenant-name" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('tenantName')?.invalid && tenantForm.get('tenantName')?.touched">
                      <span class="text-red-600">Tenant name is required.</span>
                    </div>
                  </div>
                  <!-- Contact Email (Required) -->
                  <div class="sm:col-span-2">
                    <label for="contact-email" class="block text-sm font-medium leading-6 text-gray-900">
                      Contact Email <span class="text-red-600">*</span>
                    </label>
                    <div class="mt-2">
                      <input formControlName="contactEmail" type="email" id="contact-email" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('contactEmail')?.invalid && tenantForm.get('contactEmail')?.touched">
                      <span class="text-red-600">Valid email is required.</span>
                    </div>
                  </div>
                  <!-- Phone Number (Required) -->
                  <div class="sm:col-span-2">
                    <label for="tenant-phone" class="block text-sm font-medium leading-6 text-gray-900">
                      Phone Number <span class="text-red-600">*</span>
                    </label>
                    <div class="mt-2">
                      <input formControlName="tenantPhone" type="tel" id="tenant-phone" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('tenantPhone')?.invalid && tenantForm.get('tenantPhone')?.touched">
                      <span class="text-red-600">Phone number is required.</span>
                    </div>
                  </div>
                  <!-- Website -->
                  <div class="sm:col-span-2">
                    <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Website</label>
                    <div class="mt-2">
                      <input formControlName="website" type="url" id="website" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- Logo URL -->
                  <div class="sm:col-span-2">
                    <label for="logo-url" class="block text-sm font-medium leading-6 text-gray-900">Logo URL</label>
                    <div class="mt-2">
                      <input formControlName="logoUrl" type="url" id="logo-url" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- Tenant Type (Required) -->
                  <div class="sm:col-span-2">
                    <label for="type" class="block text-sm font-medium leading-6 text-gray-900">
                      Tenant Type <span class="text-red-600">*</span>
                    </label>
                    <div class="mt-2">
                      <select formControlName="type" id="type" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                        <option selected value="shop">Corporate Shop</option>
                        <option value="corporate">Corporation (Entity)</option>
                        <option disabled value="individual">Individual</option>
                        <option disabled value="smallbiz">Small Business</option>
                      </select>
                    </div>
                  </div>
                  <!-- Parent Tenant -->
                  <div class="sm:col-span-2" *ngIf="tenantForm.get('type')?.value === 'shop'">
                    <label for="parent-tenant" class="block text-sm font-medium leading-6 text-gray-900">Parent Corporate Tenant</label>
                    <div class="mt-2">
                      <input formControlName="parentTenant" type="text" id="parent-tenant" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
  
          <!-- Tenant Address Card -->
          <div class="bg-white shadow-lg ring-1 ring-gray-900/10 sm:rounded-xl w-full">
            <div class="px-4 py-6 sm:p-8">
              <fieldset class="space-y-6">
                <legend class="text-lg font-semibold leading-6 text-gray-900">Tenant Address</legend>
                <!-- Add formGroupName="address" to bind these controls to the address group -->
                <div formGroupName="address" class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
                  <!-- Address Line 1 -->
                  <div class="sm:col-span-2">
                    <label for="address-line1" class="block text-sm font-medium leading-6 text-gray-900">Address Line 1</label>
                    <div class="mt-2">
                      <input formControlName="line1" type="text" id="address-line1" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- Address Line 2 -->
                  <div class="sm:col-span-2">
                    <label for="address-line2" class="block text-sm font-medium leading-6 text-gray-900">Address Line 2</label>
                    <div class="mt-2">
                      <input formControlName="line2" type="text" id="address-line2" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- City -->
                  <div class="sm:col-span-1">
                    <label for="city" class="block text-sm font-medium leading-6 text-gray-900">City</label>
                    <div class="mt-2">
                      <input formControlName="city" type="text" id="city" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- State -->
                  <div class="sm:col-span-1">
                    <label for="state" class="block text-sm font-medium leading-6 text-gray-900">State</label>
                    <div class="mt-2">
                      <input formControlName="state" type="text" id="state" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- Zip Code -->
                  <div class="sm:col-span-1">
                    <label for="zip-code" class="block text-sm font-medium leading-6 text-gray-900">Zip Code</label>
                    <div class="mt-2">
                      <input formControlName="zipCode" type="text" id="zip-code" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                  <!-- Country -->
                  <div class="sm:col-span-1">
                    <label for="country" class="block text-sm font-medium leading-6 text-gray-900">Country</label>
                    <div class="mt-2">
                      <input formControlName="country" type="text" id="country" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          
  
          <!-- Admin Information Card -->
          <div class="bg-white shadow-lg ring-1 ring-gray-900/10 sm:rounded-xl w-full">
            <div class="px-4 py-6 sm:p-8">
              <fieldset class="space-y-6">
                <legend class="text-lg font-semibold leading-6 text-gray-900">Admin Information</legend>
                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
                  <!-- Admin Name (Required) -->
                  <div class="sm:col-span-2">
                    <label for="first-name" class="block text-sm font-medium leading-6 text-gray-900">Name <span class="text-red-600">*</span></label>
                    <div class="mt-2">
                      <input formControlName="adminName" type="text" id="adminName" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('adminName')?.invalid && tenantForm.get('adminName')?.touched">
                      <span class="text-red-600">Name is required.</span>
                    </div>
                  </div>
                 
                  <!-- Admin Email (Required) -->
                  <div class="sm:col-span-2">
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address <span class="text-red-600">*</span></label>
                    <div class="mt-2">
                      <input formControlName="adminEmail" type="email" id="email" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('adminEmail')?.invalid && tenantForm.get('adminEmail')?.touched">
                      <span class="text-red-600">Valid email is required.</span>
                    </div>
                  </div>
                  <!-- Admin Phone
                  <div class="sm:col-span-2">
                    <label for="adminPhone" class="block text-sm font-medium leading-6 text-gray-900">Phone number</label>
                    <div class="mt-2">
                      <input formControlName="adminPhone" type="tel" id="adminPhone" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div> -->
                </div>
              </fieldset>
            </div>
          </div>
  
          <!-- Admin Account Details Card -->
          <div class="bg-white shadow-lg ring-1 ring-gray-900/10 sm:rounded-xl w-full">
            <div class="px-4 py-6 sm:p-8">
              <fieldset class="space-y-6">
                <legend class="text-lg font-semibold leading-6 text-gray-900">Admin Account Details</legend>
                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
                  <!-- Role (Required) -->
                  <div class="sm:col-span-2">
                    <label for="role" class="block text-sm font-medium leading-6 text-gray-900">Role <span class="text-red-600">*</span></label>
                    <div class="mt-2">
                      <select formControlName="adminRole" id="role" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                        <option value="gm">General Manger</option>
                      </select>
                    </div>
                  </div>
                  <!-- Password (Required) -->
                  <!-- <div class="sm:col-span-2">
                    <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password <span class="text-red-600">*</span></label>
                    <div class="mt-2">
                      <input formControlName="adminPassword" type="password" id="password" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm" required>
                    </div>
                    <div *ngIf="tenantForm.get('adminPassword')?.invalid && tenantForm.get('adminPassword')?.touched">
                      <span class="text-red-600">Password is required.</span>
                    </div>
                  </div> -->
                  <!-- Confirm Password -->
                  <!-- <div class="sm:col-span-2">
                    <label for="confirm-password" class="block text-sm font-medium leading-6 text-gray-900">Confirm Password</label>
                    <div class="mt-2">
                      <input disabled="disabled" formControlName="adminConfirmPassword" type="password" id="confirm-password" class="block w-full rounded-md border-gray-300 py-2 px-3 text-gray-900 shadow-sm">
                    </div>
                  </div> -->
                </div>
              </fieldset>
            </div>
          </div>
  
        </div>
      </div>
  
      <!-- Form Actions -->
      <div class="w-full max-w-6xl flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
        <button type="button" class="text-sm font-semibold leading-6 text-gray-900 hover:text-gray-700">Cancel</button>
        <button type="submit" class="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2">Save</button>
      </div>
    </div>
  </form>
  